export default __webpack_public_path__ + "static/media/RotateLeft.836ddaff.svg";